import React from 'react';
import UiContent from '../../../Components/Common/UiContent';
import BreadCrumb from '../../../Components/Common/BreadCrumb';
import { Container } from 'reactstrap';

//redux
import TransferCompaniesList from './TransferCompaniesList';

const TransferCompanies = () => {
	const breadcrumbLinks = [
		{ to: '#', label: 'Inicio', icon: 'icon-house' },
		{ to: '#', label: 'Logística', icon: 'icon-map-pinned' },
	];

	return (
		<React.Fragment>
			<UiContent />
			<div className='page-content'>
				<Container fluid>
					<BreadCrumb title='Empresa de transporte' links={breadcrumbLinks} icon={'icon-hand-coins'} />
					<TransferCompaniesList/>
				</Container>
			</div>
		</React.Fragment>
	);
};

export default TransferCompanies;